export { default } from './QrVideoView';



// WEBPACK FOOTER //
// ./src/components/views/QrVideoView/index.js